import * as React from 'react';
import Tooltip from 'components/tooltip';
import * as ItemsSelector from 'components/items_selector/items_selector';
import Form from 'components/form';
import { Page, Subscriber } from 'resources/types';
import UnsubscribeConfirmationModal from './unsubscribe_confirmation_modal';
import notify, { Method } from 'utils/notify';

import Heading from './heading';

declare global {
  interface Window {
    Routes: any;
  }
}

const tooltipTitle = (subscriber: Subscriber, page: Page): string =>
  `This page allows you to fine-tune which components matter to you. You will receive ${Subscriber.displayMode(
    subscriber,
  )} notifications when ${
    page.name
  } is having an issue that affects any of the selected components.`;

interface ManageSubscriptionProps {
  page: Page;
  subscriber: Subscriber;
  components: any[];
  selectedComponentIds: string[];
}

const unsubscribe = (page: Page, subscriber: Subscriber): void => {
  $('#modal-confirmation-confirmationModalId').modal();
};

const onConfirmUnsubscribe = (page: Page, subscriber: Subscriber): void => {
  $.ajax({
    url: `/unsubscribe/${subscriber.id}.json`,
    type: 'DELETE',
    dataType: 'json',

    complete: response => {
      notify('You have been unsubscribed!', { method: Method.DEFERRED });
      window.location.href = window.location.origin;
    },
    error: error => {
      notify(
        'You could not be unsubscribed. Contact support if this problem persists.',
        { method: Method.SHOW },
      );
      console.error('Failed to unsubscribe subscriber.', error);
    },
  });
};

const ManageSubscription = ({
  page,
  subscriber,
  components,
  selectedComponentIds,
}: ManageSubscriptionProps) => {
  return (
    <div>
      <Heading
        subscriber={subscriber}
        onUnsubscribe={() => unsubscribe(page, subscriber)}
      />
      <Form action={window.Routes.manage_path(subscriber.id)} method="PATCH">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>
            <strong>Components</strong>{' '}
            <small>
              (<a
                href="#"
                style={{ cursor: 'pointer' }}
                data-js-hook="toggle-all"
                id="component-selector-toggle"
              >
                Toggle all
              </a>)
            </small>
          </span>

          <Tooltip title={tooltipTitle(subscriber, page)}>
            <small>What's this?</small>
          </Tooltip>
        </div>

        <ItemsSelector
          className="inline"
          items={components}
          preselectedItemIds={selectedComponentIds}
          showHeader={false}
          showFooter={false}
          hiddenFieldName="subscriber[component_ids]"
          toggleAllclickTargetId="component-selector-toggle"
        />

        <div className="form-actions">
          <button className="flat-button" type="submit">
            Update Preferences
          </button>
        </div>
      </Form>
      <UnsubscribeConfirmationModal
        page={page}
        subscriber={subscriber}
        onConfirm={() => onConfirmUnsubscribe(page, subscriber)}
      />
    </div>
  );
};

export default ManageSubscription;



// WEBPACK FOOTER //
// ./app/javascript/containers/status/manage/index.tsx